import React, { useState } from "react";
import { Button } from "../ui/button";
import { X, Plus, Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

const AddSkills = ({ value = [], onChange, options }) => {
  const [tempSelected, setTempSelected] = useState([]);
  const [open, setOpen] = useState(false);

  const toggleTempSkill = (id) => {
    setTempSelected((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleAddSkills = () => {
    if (tempSelected.length === 0) return;

    const newSkills = tempSelected.filter((id) => !value.includes(id));

    onChange([...value, ...newSkills]);
    setTempSelected([]);
    setOpen(false);
  };

  const removeSkill = (id) => {
    onChange(value.filter((s) => s !== id));
  };

  const getLabel = (id) => {
    const found = options.find((opt) => opt.value === id);
    return found ? found.label : id;
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-3 items-center">
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className="flex-1 justify-start text-muted-foreground font-normal hover:bg-background border-input"
            >
              {tempSelected.length > 0
                ? `${tempSelected.length} skills selected`
                : "Select skills..."}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-[300px] p-0 bg-white shadow-md border" align="start">
            <div className="max-h-[300px] overflow-y-auto p-2">
              {options.map((opt) => {
                const isSelected = tempSelected.includes(opt.value);
                const isAlreadyAdded = value.includes(opt.value);

                return (
                  <div
                    key={opt.value}
                    onClick={() => !isAlreadyAdded && toggleTempSkill(opt.value)}
                    className={`flex items-center justify-between px-2 py-2 rounded-sm cursor-pointer hover:bg-slate-100 text-sm ${
                        isAlreadyAdded ? "opacity-40 cursor-not-allowed bg-slate-50" : ""
                    } ${isSelected ? "bg-slate-100" : ""}`}
                  >
                    <span>{opt.label}</span>
                    <div className="flex items-center gap-2">
                        {isAlreadyAdded && <span className="text-[10px] font-bold text-gray-400">ADDED</span>}
                        {isSelected && <Check className="w-4 h-4 text-blue-600" />}
                    </div>
                  </div>
                );
              })}
            </div>
          </PopoverContent>
        </Popover>

        <Button
          type="button"
          onClick={handleAddSkills}
          disabled={tempSelected.length === 0}
          className="bg-button-coloured px-4 py-2 font-semibold text-white"
        >
          <Plus className="w-4 h-4 mr-1" />
          Add {tempSelected.length > 0 && `(${tempSelected.length})`}
        </Button>
      </div>

      {/* Selected Tags Display */}
      <div className="flex flex-wrap gap-2">
        {value.map((id) => (
          <div
            key={id}
            className="px-3 py-1 border border-grey-3 shadow-sm bg-white text-sm text-black font-medium rounded-lg flex items-center gap-1"
          >
            {getLabel(id)}
            <X
              className="cursor-pointer font-bold w-3 h-3 hover:text-red-500"
              onClick={() => removeSkill(id)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddSkills;
